"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAutoBucketingHistoryObject = exports.AutoBucketHistory = void 0;
var AutoBuckeHistoryStore_1 = require("./AutoBuckeHistoryStore");
Object.defineProperty(exports, "AutoBucketHistory", { enumerable: true, get: function () { return AutoBuckeHistoryStore_1.AutoBucketHistory; } });
Object.defineProperty(exports, "isAutoBucketingHistoryObject", { enumerable: true, get: function () { return AutoBuckeHistoryStore_1.isAutoBucketingHistoryObject; } });
